import whitepc from './assets/packaging/5.webp'
import cardinal from './assets/portfolio/cardinal.webp'
import cleanexDetailing from './assets/portfolio/cleanexDetailing.webp'
import ezee from './assets/portfolio/ezee.webp'
import ltt from './assets/portfolio/ltt.webp'
import velez from './assets/portfolio/velez.webp'
import leasyShot from './assets/portfolio/leasy.webp'
import tailoroneShot from './assets/portfolio/tailorone.webp'
import financialproShot from './assets/portfolio/financialpro.webp'
import canwaitShot from './assets/portfolio/canwait.webp'
import tasklyftShot from './assets/portfolio/tasklyft.webp'
import barberproShot from './assets/portfolio/barberpro.webp'
import freshcutlawnbcShot from './assets/portfolio/freshcutlawnbc.webp'
import sevenStepsFinancialShot from './assets/portfolio/7stepsfinancial.webp'
import lindsayGrimleyShot from './assets/portfolio/lindsaygrimley.webp'
import westviewCleaningShot from './assets/portfolio/westviewcleaning.webp'

/** Shipped sites for paying clients - production launches. */
export const PortfolioClientWork = [
  {
    name: 'WestView Cleaning Services',
    desc: 'Cleaning services, Vancouver & Lower Mainland, BC',
    year: 2026,
    img: westviewCleaningShot,
    link: 'https://www.westviewcleaningservices.ca',
  },
  {
    name: 'Lindsay Grimley',
    desc: 'Cobourg city council election campaign',
    year: 2026,
    img: lindsayGrimleyShot,
    link: 'https://lindsaygrimley.ca/',
  },
  {
    name: '7 Steps Financial',
    desc: 'Financial planning & consulting, Langley, BC',
    year: 2026,
    img: sevenStepsFinancialShot,
    link: 'https://7stepsfinancial.com/',
  },
  {
    name: 'Fresh Cut Lawn BC',
    desc: 'Lawn care & landscaping, Mission, BC',
    year: 2026,
    img: freshcutlawnbcShot,
    link: 'https://freshcutlawnbc.ca/',
  },
  {
    name: 'TaskLyft',
    desc: 'Field service software for trades - customers, calendar, invoices, teams',
    year: 2026,
    img: tasklyftShot,
    link: 'https://tasklyft.ca/',
  },
  {
    name: 'Cardinal Services Group',
    desc: 'Hvac company, Windsor, ON',
    year: 2019,
    img: cardinal,
    link: 'https://www.cardinalservicesgroup.com',
  },
  {
    name: 'London Top Tailoring',
    desc: 'Best Tailor, London, ON',
    year: 2017,
    img: ltt,
    link: 'https://www.londontoptailoring.com',
  },
  {
    name: 'Cleanex Detailing - Studio & Mobile',
    desc: 'Cleanex Detailing, Coquitlam, BC',
    year: 2024,
    img: cleanexDetailing,
    link: 'https://www.cleanexdetailing.com/',
  },
  {
    name: 'Ezee Computer Training',
    desc: 'Computer training, London, ON',
    year: 2017,
    img: ezee,
    link: 'https://www.ezeecomputertraining.com',
  },
  {
    name: 'Velezfit',
    desc: 'Personal training, London, ON',
    year: 2017,
    img: velez,
    link: 'http://www.velezfit.ca',
  },
]

/** Internal experiments and product concepts - not full commercial launches. */
export const PortfolioLabWork = [
  {
    name: 'BarberPro',
    desc: 'Barber shops - online booking, clients, and chair scheduling',
    year: 2026,
    img: barberproShot,
    link: 'https://barberpro.elementarycreative.com/',
  },
  {
    name: 'Leasy',
    desc: 'Property management - rent, maintenance, tenants',
    year: 2026,
    img: leasyShot,
    link: 'https://tryleasy.ca/',
  },
  {
    name: 'TailorOne',
    desc: 'Studio CRM - clients, orders, fittings, and production tracking',
    year: 2026,
    img: tailoroneShot,
    link: 'https://tailorone.elementarycreative.com/',
  },
  {
    name: 'Financial Pro',
    desc: 'Financial services web experience',
    year: 2026,
    img: financialproShot,
    link: 'https://financialpro.elementarycreative.com/',
  },
  {
    name: 'CanWait',
    desc: 'Business waitlist & queue management',
    year: 2025,
    img: canwaitShot,
    link: 'https://canwait-prod.web.app/',
  },
]

/** @deprecated Use PortfolioClientWork + PortfolioLabWork; kept for any legacy imports. */
export const PortfolioData = [...PortfolioClientWork, ...PortfolioLabWork]

export const PackagingData = [
  {
    name: 'White Packaging Presentation Clicker',
    desc: 'Vancouver, BC, Canada',
    img: whitepc,
    link: 'https://www.londontoptailoring.com',
  },
]
